const supportedLocales = ["en", "fa", "sv"];

export const getSupportedLocale = (locale) => {
  const browserLocale = locale || (typeof navigator !== "undefined" ? navigator.language : "sv");
  const language = browserLocale.split("-")[0].toLowerCase();
  return supportedLocales.includes(language) ? language : "sv";
};